import { useState } from "react";
import { ArrowTopRightOnSquareIcon } from "@heroicons/react/24/outline";

const extractMeetupEventId = (input) => {
  if (!input) return { id: "", isValid: true };

  const trimmedInput = input.trim();

  if (/^\d+$/.test(trimmedInput)) {
    return { id: trimmedInput, isValid: true };
  }

  const meetupUrlPattern =
    /^https?:\/\/(www\.)?meetup\.com\/[^/]+\/events\/(\d+)\/?/;
  const match = trimmedInput.match(meetupUrlPattern);

  if (match && match[2]) {
    return { id: match[2], isValid: true };
  }

  if (
    trimmedInput.startsWith("http://") ||
    trimmedInput.startsWith("https://")
  ) {
    return { id: trimmedInput, isValid: false };
  }

  return { id: trimmedInput, isValid: true };
};

const getMeetupUrl = (value) =>
  value && /^\d+$/.test(value)
    ? `https://www.meetup.com/gist-irl/events/${value}/`
    : null;

const MeetupEventIdInput = ({ value, onChange }) => {
  const [showWarning, setShowWarning] = useState(false);
  const meetupUrl = getMeetupUrl(value);

  const handleChange = (e) => {
    const { id, isValid } = extractMeetupEventId(e.target.value);

    if (
      !isValid &&
      (e.target.value.startsWith("http://") ||
        e.target.value.startsWith("https://"))
    ) {
      setShowWarning(true);
      onChange({ target: { value: "" } });
      setTimeout(() => setShowWarning(false), 3000);
      return;
    }

    setShowWarning(false);
    onChange({ target: { value: id } });
  };

  return (
    <div>
      <label
        htmlFor="meetupEventId"
        className="block text-sm font-medium leading-6 text-gray-500 dark:text-gray-400"
      >
        Meetup Event URL or ID
      </label>
      <div className="relative mt-1">
        <input
          onChange={handleChange}
          id="meetupEventId"
          value={value}
          type="text"
          placeholder="Enter Meetup event ID or full URL"
          className={`px-4 block w-full rounded-md border-0 py-1.5 text-gray-900 dark:text-gray-100 dark:bg-gray-800 shadow-sm ring-1 ring-inset ring-gray-300 dark:ring-gray-600 placeholder:text-gray-400 dark:placeholder:text-gray-500 focus:ring-2 focus:ring-inset focus:ring-primary text-sm sm:text-base sm:leading-6 ${
            meetupUrl ? "pr-10" : ""
          }`}
        />
        {meetupUrl && (
          <div className="absolute inset-y-0 right-0 flex items-center pr-3">
            <a
              href={meetupUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-400 dark:text-gray-500 hover:text-primary transition-colors"
              title="Open on Meetup"
            >
              <ArrowTopRightOnSquareIcon className="h-5 w-5" />
            </a>
          </div>
        )}
      </div>
      {showWarning && (
        <div className="mt-2 p-2 bg-yellow-50 dark:bg-yellow-900/30 border border-yellow-200 dark:border-yellow-800 rounded-md">
          <p className="text-sm text-yellow-800 dark:text-yellow-200">
            Please enter a valid Meetup URL or just the event ID
          </p>
        </div>
      )}
    </div>
  );
};

export default MeetupEventIdInput;
